import { Heading2XL, Heading5XL } from "../../../typography";

import { FeatureSection } from "../../components/sections/FeatureSection";
import { featureSections } from "../config/lifeAtVerseConfig";

export const DarkSection = () => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-rounded-[2em] tw-bg-[#000973] tw-bg-[url('/landing_page_assets/backgrounds/bg3.jpg')] tw-bg-cover tw-bg-bottom tw-px-[1.25em] tw-py-[5em] min440:tw-py-[7.5em] min840:tw-px-[13.625em]">
      <div className="tw-flex tw-max-w-[72.75em] tw-flex-col tw-items-baseline tw-gap-y-[2.625em] min440:tw-items-center min440:tw-gap-y-[4em]">
        <div className="tw-flex tw-flex-col tw-items-center ">
          <Heading5XL className="tw-my-0 tw-hidden tw-text-white min440:tw-flex">
            Why Verse
          </Heading5XL>
          <Heading2XL className="tw-my-0 tw-text-white min440:tw-hidden">
            Why Verse
          </Heading2XL>
        </div>
        {featureSections.map((section, index) => (
          <FeatureSection
            key={`feature-section-${index}`}
            {...section}
            textClassName="tw-text-white"
            hasJobOpeningsButton
          />
        ))}
      </div>
    </div>
  );
};
